import React, { useRef, useState, useEffect } from "react";

export default function IsonTube() {
  const title = "Work Lo-fi Focus/Concentration";
  const description =
    "The perfect lo-fi background music for deep focus and productivity. Slow beats, cozy vibes, and smooth rhythms that help you concentrate while working, studying, coding, reading, or simply unwinding";

  const likes = 183;
  const comments = 24;

  const videoRef = useRef(null);
  const [hidePoster, setHidePoster] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const handlePlay = () => {
    setHidePoster(true);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key !== "Enter") return;
      const video = videoRef.current;
      if (!video || video.paused) return;

      e.preventDefault();
      video.pause();
      setShowModal(true);
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleNastavi = () => {
    setShowModal(false);
    videoRef.current?.play().catch(() => {});
  };

  return (
    <div className="ison-tube-page">
      <div className="ison-tube-logo">ison tube</div>

      <div className="ison-tube-video-wrapper">
        <video
          ref={videoRef}
          className="ison-tube-video"
          controls
          poster={hidePoster ? "" : "/images/ison_tube_lofi.jpg"}
          onPlay={handlePlay}
        >
          <source src="/images/lofi_video.mp4" type="video/mp4" />
        </video>
      </div>

      <div className="ison-tube-content">
        <h1 className="ison-tube-title">{title}</h1>
        <p className="ison-tube-description">{description}</p>

        <div className="ison-tube-meta">
          <span>{likes} likes</span>
          <span>{comments} comments</span>
        </div>

        <div className="ison-tube-actions">
          <button className="ison-tube-btn ison-tube-share">Share</button>
          <button className="ison-tube-btn ison-tube-subscribe">
            Subscribe
          </button>
        </div>
      </div>

      {showModal && (
        <div className="ison-tube-modal-overlay">
          <div className="ison-tube-modal">
            <p>Da li i dalje gledaš?</p>
            <button onClick={handleNastavi}>Nastavi</button>
          </div>
        </div>
      )}
    </div>
  );
}
